module.exports = __webpack_public_path__ + "img/kiosk-mach-map.b6484b4a.webp";